export const finding = {
  routes: [
    {
      path: "/finding",
      component: () => import("../organization-finding-view"),
    },
    {
      path: "/finding/detail/:id",
      component: () => import("../organization-finding-detail"),
      name: "organizationFindingDetail",
    },
    {
      path: "/finding/view",
      component: () => import("../organization-finding-view"),
    },
    {
      path: "/finding/reports",
      // component: () => import("../organization-finding-view"),
    },
    {
      path: "/finding/file-manager",
      // component: () => import("../organization-finding-view"),
    },
    {
      path: "/finding/target",
      component: () => import("../organization-finding-target-view"),
    },
    // {
    //   path: "/management/library/finding-source",
    //   component: () => import("../library/management-library-finding-source-view"),
    // },
    // {
    //   path: "/management/library/finding-sub-source",
    //   component: () => import("../library/management-library-finding-sub-source-view"),
    // },
    // {
    //   path: "/management/library/finding-root-cause",
    //   component: () => import("../library/management-library-finding-root-cause-view"),
    // },
    // {
    //   path: "/management/library/finding-category",
    //   component: () => import("../library/management-library-finding-category-view"),
    // },
  ],
};
export const management = {
  routes: [
    {
      path: "/management/library/finding-type",
      component: () => import("../library/management-library-finding-type-view"),
    },
    // {
    //   path: "/management/library/finding-sub-source",
    //   component: () => import("../library/management-library-finding-sub-source-view"),
    // },
    {
      path: "/management/library/finding-root-cause",
      component: () => import("../library/management-library-finding-root-cause-view"),
    },
    {
      path: "/management/library/finding-category",
      component: () => import("../library/management-library-finding-category-view"),
    },
  ],
};
